import { Mail, Github, Phone } from 'lucide-react'

export default function Footer() {
  const year = new Date().getFullYear()

  const links = {
    产品: [
      { name: '功能特色', href: '#features' },
      { name: '工作原理', href: '#how-it-works' },
      { name: '数据成果', href: '#stats' },
      { name: '立即体验', href: '#download' },
    ],
    支持: [
      { name: '帮助中心', href: '#' },
      { name: '联系我们', href: 'mailto:contact@lafit-ai.com' },
      { name: '隐私政策', href: '#' },
      { name: '服务条款', href: '#' },
    ],
  }

  return (
    <footer className="relative border-t border-white/5 pt-16 pb-8">
      {/* 背景 */}
      <div className="absolute inset-0 grid-bg opacity-20 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* 品牌区 */}
          <div className="md:col-span-2">
            {/* Logo */}
            <div className="flex items-center gap-2.5 mb-4">
              <img
                src="/images/lafit-logo.png"
                alt="Lafit Logo"
                className="h-7 w-auto"
                style={{ filter: 'brightness(1.1)' }}
              />
            </div>

            <p className="text-sm text-gray-500 leading-relaxed max-w-sm mb-6">
              专注网球运动数字化，旗下产品覆盖 AI 动作分析、场馆在线预订、
              挑战赛排行全场景，为网球爱好者提供智能化训练体验。
            </p>

            {/* 联系/链接 */}
            <div className="flex gap-3 mb-4">
              <a
                href="https://gitlab.com/lafit/AI-Coach"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg flex items-center justify-center text-gray-500 hover:text-white transition-all"
                style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)' }}
                title="GitLab"
              >
                <Github className="w-4 h-4" />
              </a>
              <a
                href="mailto:info@lafit.club"
                className="w-9 h-9 rounded-lg flex items-center justify-center text-gray-500 hover:text-blue-400 transition-all"
                style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)' }}
                title="Email"
              >
                <Mail className="w-4 h-4" />
              </a>
            </div>

            {/* 联系方式 */}
            <div className="space-y-2 text-sm text-gray-500">
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4" />
                <span>400-8365-001</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <a href="mailto:info@lafit.club" className="hover:text-blue-400 transition-colors">info@lafit.club</a>
              </div>
            </div>
          </div>

          {/* 链接列 */}
          {Object.entries(links).map(([category, items]) => (
            <div key={category}>
              <h4 className="text-sm font-semibold text-white mb-4">{category}</h4>
              <ul className="space-y-2.5">
                {items.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      className="text-sm text-gray-500 hover:text-gray-200 transition-colors"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 分割线 */}
        <div className="h-px mb-6" style={{ background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.06), transparent)' }} />

        {/* 底部版权 */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-400">
          <p>© {year} Lafit智拍AI网球教练 · Lafit Technology. All rights reserved.</p>
          <div className="flex flex-col md:flex-row items-center gap-3">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-blue-400 transition-colors"
            >
              沪ICP备18027581号-2
            </a>
            <span className="hidden md:inline">·</span>
            <p>让每一次挥拍都有价值 · 用 AI 重新定义网球训练</p>
          </div>
        </div>
      </div>
    </footer>
  )
}
